/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";
import PropTypes from "prop-types";
import BrokingBannerCta from "./BrokingBannerCta";

const propTypes = {
  rCode: PropTypes.string
};

const BrokingBannerCtaContainer = ({rCode}) => {
  const [toggleModal, setToggleModal] = useState(false);

  return (
    <BrokingBannerCta
      rCode={rCode}
      setToggleModal={setToggleModal}
      toggleModal={toggleModal}
    />
  );
};

BrokingBannerCtaContainer.propTypes = propTypes;

export default BrokingBannerCtaContainer;
